import { render } from "./OfferTrade.vue?vue&type=template&id=6abda9ee"
import script from "./OfferTrade.vue?vue&type=script&lang=js"
export * from "./OfferTrade.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__